import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import translationEN from '../locales/en/translation.json';
import translationFR from '../locales/fr/translation.json';
import translationZH from '../locales/zh/translation.json';
import heroSectionMainEN from '../locales/en/heroSectionMain.json';
import heroSectionMainFR from '../locales/fr/heroSectionMain.json';
import heroSectionMainZH from '../locales/zh/heroSectionMain.json';
import ourSolutionSectionEN from '../locales/en/ourSolutionSection.json';
import ourSolutionSectionFR from '../locales/fr/ourSolutionSection.json';
import ourSolutionSectionZH from '../locales/zh/ourSolutionSection.json';
import aboutUsSectionEN from '../locales/en/aboutUsSection.json';
import aboutUsSectionFR from '../locales/fr/aboutUsSection.json';
import aboutUsSectionZH from '../locales/zh/aboutUsSection.json';
import downloadBrochureModalEN from '../locales/en/downloadBrochureModal.json';
import downloadBrochureModalFR from '../locales/fr/downloadBrochureModal.json';
import downloadBrochureModalZH from '../locales/zh/downloadBrochureModal.json';
import weServeSectionEN from '../locales/en/weServeSection.json';
import weServeSectionFR from '../locales/fr/weServeSection.json';
import weServeSectionZH from '../locales/zh/weServeSection.json';
import getStartedSectionEN from '../locales/en/getStartedSection.json';
import getStartedSectionFR from '../locales/fr/getStartedSection.json';
import getStartedSectionZH from '../locales/zh/getStartedSection.json';
import footerSectionEN from '../locales/en/footerSection.json';
import footerSectionFR from '../locales/fr/footerSection.json';
import footerSectionZH from '../locales/zh/footerSection.json';
import solutionsSectionEN from '../locales/en/solutionsSection.json';
import solutionsSectionFR from '../locales/fr/solutionsSection.json';
import solutionsSectionZH from '../locales/zh/solutionsSection.json';
import partnersSectionEN from '../locales/en/partnersSection.json';
import partnersSectionFR from '../locales/fr/partnersSection.json';
import partnersSectionZH from '../locales/zh/partnersSection.json';
import industriesSectionEN from '../locales/en/industriesSection.json';
import industriesSectionFR from '../locales/fr/industriesSection.json';
import industriesSectionZH from '../locales/zh/industriesSection.json';
import projectsSectionEN from '../locales/en/projectsSection.json';
import projectsSectionFR from '../locales/fr/projectsSection.json';
import projectsSectionZH from '../locales/zh/projectsSection.json';
import aboutContactSectionEN from '../locales/en/aboutContactSection.json';
import aboutContactSectionFR from '../locales/fr/aboutContactSection.json';
import aboutContactSectionZH from '../locales/zh/aboutContactSection.json';
import chatbotSectionEN from '../locales/en/chatbotSection.json';
import chatbotSectionFR from '../locales/fr/chatbotSection.json';
import chatbotSectionZH from '../locales/zh/chatbotSection.json';

// Translation resources
const resources = {
  en: {
    translation: {
      ...translationEN,
      ...heroSectionMainEN,
      ...ourSolutionSectionEN,
      ...aboutUsSectionEN,
      ...downloadBrochureModalEN,
      ...weServeSectionEN,
      ...getStartedSectionEN,
      ...footerSectionEN,
      ...solutionsSectionEN,
      ...partnersSectionEN,
      ...industriesSectionEN,
      ...projectsSectionEN,
      ...aboutContactSectionEN,
      ...chatbotSectionEN,
    }
  },
  fr: {
    translation: {
      ...translationFR,
      ...heroSectionMainFR,
      ...ourSolutionSectionFR,
      ...aboutUsSectionFR,
      ...downloadBrochureModalFR,
      ...weServeSectionFR,
      ...getStartedSectionFR,
      ...footerSectionFR,
      ...solutionsSectionFR,
      ...partnersSectionFR,
      ...industriesSectionFR,
      ...projectsSectionFR,
      ...aboutContactSectionFR,
      ...chatbotSectionFR,
    }
  },
  zh: {
    translation: {
      ...translationZH,
      ...heroSectionMainZH,
      ...ourSolutionSectionZH,
      ...aboutUsSectionZH,
      ...downloadBrochureModalZH,
      ...weServeSectionZH,
      ...getStartedSectionZH,
      ...footerSectionZH,
      ...solutionsSectionZH,
      ...partnersSectionZH,
      ...industriesSectionZH,
      ...projectsSectionZH,
      ...aboutContactSectionZH,
      ...chatbotSectionZH,
    }
  }
};

i18n
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    resources,
    fallbackLng: 'en', // Default language
    lng: 'en', // Initial language
    debug: false,
    
    interpolation: {
      escapeValue: false // React already escapes values
    },
    
    detection: {
      // Order of language detection
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n;
